import * as normalizr from 'normalizr'
import * as R from 'ramda'
import { records } from '@ims/1edtech-frontend-common'

import { prepareRESTCharacterizationForServer } from 'domains/characterizations/utils/prepareRESTCharacterizationForServer'

export const OR_REST_CHARACTERIZATIONS_RECORD = 'orRESTCharacterizations'

const restCharacterizations: records.modules.IModule = {
  record: OR_REST_CHARACTERIZATIONS_RECORD,
  responseDataKey: 'characterizationReport',
  schema: new normalizr.schema.Entity(
    OR_REST_CHARACTERIZATIONS_RECORD,
    {},
    records.modules.utils.getSchemaOptions(),
  ),
  api: {
    create: () => 'characterizations/rest',
    prepareCreateData: prepareRESTCharacterizationForServer,
    get: (id) => `characterizations/rest/${id}`,
    getList: (params, orgId) => {
      const formatId = R.propOr(false, 'formatId', params)
      if (formatId) {
        return `formats/${formatId}/characterizations`
      }
      return `organizations/${orgId}/characterizations`
    },
    update: (id) => `characterizations/rest/${id}`,
    delete: (id) => `characterizations/${id}`,
  },
}

export default restCharacterizations
